module.exports = __webpack_public_path__ + "static/media/GST_details.f7ddf7d4.csv";